<template>
  <v-dialog
      v-model="showDialog"
      max-width="800px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Generelle Schnittstelleneinstellungen</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <h5>Grundeinstellungen</h5>
          <v-select
                    :items="formatSelects"
                    label="Dateiformat"
                    v-model="definitionInternal.format"
          ></v-select>
          <v-text-field
              v-if="definitionInternal.format === 'delimiter' || definitionInternal.format === 'csv'"
              label="Trennzeichen"
              hint="Bei csv wird , als Standart verwendet, bei Abweichung bitte eintragen."
              v-model="definitionInternal.delimiter"
          ></v-text-field>
          <v-select
              v-if="definitionInternal.format === 'template'"
              class="blue-chips"
              v-model="definitionInternal.template_file"
              :items="template_files"
              label="Template Datei"
              chips
              deletable-chips
              :append-outer-icon="'mdi-cloud-upload'"
              @click:append-outer=""
          ></v-select>
          <v-text-field
              label="Fester Dateiname"
              v-model="definitionInternal.fixed_filename"
          ></v-text-field>
          <h5>Ausgabeeinstellungen</h5>
          <v-row>
            <v-col>
              <v-checkbox
                  v-model="definitionInternal.use_field_names"
                  label="Feldnamen"
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.use_overwrite"
                  label="überschreiben"
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.skip_cancellation"
                  label="kein Storno"
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.use_lead_in_line"
                  label="Vorlaufzeile verwenden"
                  hide-details
              ></v-checkbox>
              <v-text-field
                  v-if="definitionInternal.use_lead_in_line"
                  label="Vorlaufzeile"
                  v-model="definitionInternal.lead_in_line"
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-checkbox
                  v-model="definitionInternal.combine_assumption_payout"
                  label="Eine Datei für Annahme/Ausz."
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.only_assumption"
                  label="nur Annahme"
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.only_assumption_extern"
                  label="nur Annahme für extern"
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.only_payout"
                  label="nur Auszahlung"
                  hide-details
              ></v-checkbox>
              <v-checkbox
                  v-model="definitionInternal.use_details"
                  label="Details"
                  hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
        >
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: "DefinitionSettingsDialog",
  props: {
    definition: {
      type: Object,
      default: () => {
        return {
          id: "new",
          api_name: "",
          format: "fixed_length",
          delimiter: "",
          template_file: "",
          fixed_filename: "",
          use_field_names: false,
          use_overwrite: false,
          combine_assumption_payout: true,
          only_assumption: false,
          only_assumption_extern: false,
          only_payout: false,
          use_details: false,
          skip_cancellation: false,
          use_lead_in_line: false,
          lead_in_line: "",
        }
      },
    },
    template_files: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      showDialog: false,
      error: false,
      definitionInternal: {
        id: "new",
        api_name: "",
        format: "fixed_length",
        delimiter: "",
        template_file: "",
        fixed_filename: "",
        use_field_names: false,
        use_overwrite: false,
        combine_assumption_payout: true,
        only_assumption: false,
        only_assumption_extern: false,
        only_payout: false,
        use_details: false,
        skip_cancellation: false,
        use_lead_in_line: false,
        lead_in_line: "",
      },
      formatSelects: [{text: 'feste Feldlänge', value: "fixed_length"}, {text: 'mit Trennzeichen', value: "delimiter"}, {text: 'Format CSV', value: "csv"}, {text: 'Template Datei', value: "template"}],
    }
  },
  methods: {
    show() {
      if (this.showDialog) {
        return;
      }
      this.definitionInternal = {...this.definition};
      this.showDialog = true;
    },
    submit() {
      this.$emit('submit', this.definitionInternal);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>

</style>
